const modules = {}

// 顶层 modules 目录下的 *.js
const topCtx = require.context('./modules', false, /\.js$/)
topCtx.keys().forEach((key) => {
  const name = key.replace(/^\.\//, '').replace(/\.js$/, '')
  modules[name] = topCtx(key).default
})

// 子目录 */index.js
const subCtx = require.context('./modules', true, /^\.\/[^/]+\/index\.js$/)
subCtx.keys().forEach((key) => {
  const name = key.replace(/^\.\//, '').replace(/\/index\.js$/, '')
  modules[name] = subCtx(key).default
})

export default modules
